import { HttpService } from '@/infra/http'
import type { TProduto, TTipoProdutoEnum } from '@/types/produto'

export type TGetProdutosResponse = Array<{
  nome: string
  produtos: TProduto[]
}>

export class GetProdutosService extends HttpService {
  execute = async (idExternoBloco: number, tipoDoProduto: TTipoProdutoEnum, isVagaPadrao = false) => {
    return this.http.get<TGetProdutosResponse>(
      `/api/v2/Produto/bloco/${idExternoBloco}/tipoProduto/${tipoDoProduto}?vagasPadrao=${isVagaPadrao}`,
    )
  }
}
